import React from "react";

export default ({title, button}) =>
    <div className="d-flex border-bottom mb-4 pb-2 pb-md-4 padding--negative">
        <h5 className="font-16 my-auto">
            <strong>{title}</strong>
        </h5>
        {button}
    </div>;
